import { Box, Button, Checkbox, Typography } from "@mui/material";
import { useState } from "react";
import { MdOutlineDone } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { createGroupAccordinglyQuarterlyTargetPlanAction } from "../../../redux/actions/quarterlyTargetPlanActions";
import { DatePick } from "./DatePicker/DatePicker";

const QuarterlyTargetPlanCard = ({ data, cellNumber }) => {
  const dispatch = useDispatch();
  const { courseId } = useSelector((state) => state.studentStatus);
  const { startDate, endDate } = useSelector((state) => state.datepicker);
  const { createLoading } = useSelector(
    (state) => state.quarterlyTargetPlanData,
  );
  const [dateWarningMessage, setDateWarningMessage] = useState({
    startDate: "",
    endDate: "",
  });

  const [newGroupData, setNewGroupData] = useState({
    name: data.newGroupName,
    course: data.course._id,
    startDate: "",
    endDate: "",
    room: null,
    labRoom: null,
    teachers: [],
    mentors: [],
    lessonDate: [
      {
        practical: false,
        day: data.mainDateData.days[0],
        startTime: data.mainDateData.hour.start,
        endTime: data.mainDateData.hour.end,
      },
      {
        practical: false,
        day: data.mainDateData.days[1],
        startTime: data.mainDateData.hour.start,
        endTime: data.mainDateData.hour.end,
      },
      {
        practical: true,
        day: data.labDateData.days[0],
        startTime: data.labDateData.hour.start,
        endTime: data.labDateData.hour.end,
      },
      ...(data.labDateData.days[1]
        ? [
            {
              practical: true,
              day: data.labDateData.days[1],
              startTime: data.labDateData.hour.start,
              endTime: data.labDateData.hour.end,
            },
          ]
        : []),
    ],
  });

  const setEndDateWithSyllabusCount = () => {
    let syllabusCount = data?.syllabusCount || 0;
    if (!newGroupData.startDate) return;

    const endDate = new Date(newGroupData.startDate);

    while (syllabusCount > 0) {
      if (
        endDate.getDay() === data.mainDateData.days[0] ||
        endDate.getDay() === data.mainDateData.days[1]
      ) {
        syllabusCount--;
      }

      if (syllabusCount === 0) break;

      endDate.setDate(endDate.getDate() + 1);
    }

    setNewGroupData((pre) => ({ ...pre, endDate: endDate }));
  };

  // console.log(newGroupData);
  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "white",
      }}
    >
      <Box
        sx={{
          fontSize: "16px",
          width: "130px",
          display: "flex",
          alignItems: "center",
          border: "1px solid lightgray",
          padding: "10px",
        }}
      >
        <Typography sx={{ fontSize: "16px" }}>
          {cellNumber}. {data.course.name}
        </Typography>
      </Box>
      <Box
        sx={{
          fontSize: "16px",
          width: "100px",
          display: "flex",
          alignItems: "center",
          border: "1px solid lightgray",
          padding: "10px",
        }}
      >
        <Typography sx={{ fontSize: "16px" }}>{data.newGroupName}</Typography>
      </Box>
      <Box
        sx={{ display: "flex", alignItems: "center", backgroundColor: "white" }}
      >
        <Box>
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                fontSize: "16px",
                width: "130px",
                display: "flex",
                alignItems: "center",
                border: "1px solid lightgray",
                padding: "10px",
              }}
            >
              <Typography sx={{ fontSize: "16px" }}>
                {data.mainDateData.days.join(" - ")}
              </Typography>
            </Box>
            <Box>
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    fontSize: "16px",
                    width: "130px",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid lightgray",
                    padding: "10px",
                  }}
                >
                  <Typography sx={{ fontSize: "16px" }}>
                    {data.mainDateData.hour.start} -{" "}
                    {data.mainDateData.hour.end}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: "200px",
                    border: "1px solid lightgray",
                    padding: "10px",
                  }}
                >
                  {data.mainDateData.suitableMainLessonRooms?.map((room) => (
                    <Box
                      sx={{
                        border: "1px solid gray",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "5px",
                        marginBottom: "10px",
                      }}
                    >
                      <Checkbox
                        checked={
                          room._id.toString() === newGroupData.room?.toString()
                        }
                        onChange={() =>
                          setNewGroupData((pre) => ({
                            ...pre,
                            room: pre.room === room._id ? null : room._id,
                          }))
                        }
                      />
                      <Typography sx={{ fontSize: "16px" }}>
                        {room.name}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Box
                  sx={{
                    width: "200px",
                    border: "1px solid lightgray",
                    padding: "10px",
                  }}
                >
                  {data.mainDateData?.suitableTeachers?.map((teacher) => (
                    <Box
                      sx={{
                        border: "1px solid gray",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "5px",
                        marginBottom: "10px",
                      }}
                    >
                      <Checkbox
                        checked={newGroupData.teachers.includes(teacher._id)}
                        onChange={() =>
                          setNewGroupData((pre) => ({
                            ...pre,
                            teachers: newGroupData.teachers.includes(
                              teacher._id,
                            )
                              ? newGroupData.teachers.filter(
                                  (teacherId) => teacherId !== teacher._id,
                                )
                              : [...pre.teachers, teacher._id],
                          }))
                        }
                      />
                      <Typography sx={{ fontSize: "16px" }}>
                        {teacher.fullName}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Box
                  sx={{
                    width: "200px",
                    border: "1px solid lightgray",
                    padding: "10px",
                  }}
                >
                  {data.mainDateData?.suitableMentors?.map((mentor) => (
                    <Box
                      sx={{
                        border: "1px solid gray",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "5px",
                        marginBottom: "10px",
                      }}
                    >
                      <Checkbox />
                      <Typography sx={{ fontSize: "16px" }}>
                        {mentor.fullName}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
          {/* Lab */}
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                fontSize: "16px",
                width: "130px",
                display: "flex",
                alignItems: "center",
                border: "1px solid lightgray",
                padding: "10px",
              }}
            >
              <Typography sx={{ fontSize: "16px" }}>
                {data.labDateData.days.join(" - ") + " (Lab)"}
              </Typography>
            </Box>
            <Box>
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    fontSize: "16px",
                    width: "130px",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid lightgray",
                    padding: "10px",
                  }}
                >
                  <Typography sx={{ fontSize: "16px" }}>
                    {data.labDateData.hour.start} - {data.labDateData.hour.end}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: "200px",
                    border: "1px solid lightgray",
                    padding: "10px",
                  }}
                >
                  {data.labDateData.suitableLabLessonRooms?.map((room) => (
                    <Box
                      sx={{
                        border: "1px solid gray",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "5px",
                        marginBottom: "10px",
                      }}
                    >
                      <Checkbox
                        checked={
                          room._id.toString() ===
                          newGroupData.labRoom?.toString()
                        }
                        onChange={() =>
                          setNewGroupData((pre) => ({
                            ...pre,
                            labRoom: pre.labRoom === room._id ? null : room._id,
                          }))
                        }
                      />
                      <Typography sx={{ fontSize: "16px" }}>
                        {room.name}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Box
                  sx={{
                    width: "200px",
                    border: "1px solid lightgray",
                    padding: "10px",
                  }}
                >
                  {data.labDateData?.suitableTeachers?.map((teacher) => (
                    <Box
                      sx={{
                        border: "1px solid gray",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "5px",
                        marginBottom: "10px",
                      }}
                    >
                      <Checkbox />
                      <Typography sx={{ fontSize: "16px" }}>
                        {teacher.fullName}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Box
                  sx={{
                    width: "200px",
                    border: "1px solid lightgray",
                    padding: "10px",
                  }}
                >
                  {data.labDateData?.suitableMentors?.map((mentor) => (
                    <Box
                      sx={{
                        border: "1px solid gray",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "5px",
                        marginBottom: "10px",
                      }}
                    >
                      <Checkbox
                        checked={newGroupData.mentors.includes(mentor._id)}
                        onChange={() =>
                          setNewGroupData((pre) => ({
                            ...pre,
                            mentors: newGroupData.mentors.includes(mentor._id)
                              ? newGroupData.mentors.filter(
                                  (mentorId) => mentorId !== mentor._id,
                                )
                              : [...pre.mentors, mentor._id],
                          }))
                        }
                      />
                      <Typography sx={{ fontSize: "16px" }}>
                        {mentor.fullName}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            fontSize: "16px",
            width: "180px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            border: "1px solid lightgray",
            padding: "10px",
          }}
        >
          <Typography sx={{ fontSize: "16px" }}>
            <DatePick
              newGroupData={newGroupData}
              setNewGroupData={setNewGroupData}
              type="startDate"
              setDateWarningMessage={setDateWarningMessage}
            />
            <Typography color={"red"}>
              {dateWarningMessage.startDate}
            </Typography>
          </Typography>
        </Box>
        <Box
          sx={{
            fontSize: "16px",
            width: "180px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            border: "1px solid lightgray",
            padding: "10px",
          }}
        >
          <Typography sx={{ fontSize: "16px", position: "relative" }}>
            <DatePick
              newGroupData={newGroupData}
              setNewGroupData={setNewGroupData}
              type="endDate"
              setDateWarningMessage={setDateWarningMessage}
            />
            <Typography color={"red"}>{dateWarningMessage.endDate}</Typography>

            <Button
              variant="outlined"
              sx={{
                position: "absolute",
                left: 0,
                textTransform: "lowercase",
                fontSize: "12px",
                marginTop: "5px",
              }}
              onClick={setEndDateWithSyllabusCount}
            >
              Sillabus ilə təyin et: {data?.syllabusCount || 0}
            </Button>
          </Typography>
        </Box>
        <Box
          sx={{
            width: "130px",
            padding: "10px",
            border: "1px solid lightgray",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            sx={{
              border: "1px solid gray",
              display: "flex",
              alignItems: "center",
              borderRadius: "5px",
              marginBottom: "10px",
              padding: "5px",
            }}
            color="success"
            variant="contained"
            disabled={
              !newGroupData.name ||
              !newGroupData.course ||
              !newGroupData.startDate ||
              !newGroupData.endDate ||
              !newGroupData.room ||
              !newGroupData.labRoom ||
              newGroupData.teachers.length === 0 ||
              newGroupData.mentors.length === 0 ||
              newGroupData.lessonDate.length === 0 ||
              createLoading
            }
            onClick={() => {
              dispatch(
                createGroupAccordinglyQuarterlyTargetPlanAction(
                  newGroupData,
                  startDate,
                  endDate,
                  courseId,
                ),
              );
            }}
          >
            <MdOutlineDone size={25} />
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default QuarterlyTargetPlanCard;
